import i18n from '@dms/i18n';
import {monthOptions, yearOptionsWithFuture} from '@dms/shared';

import {VehicleForm} from '../VehicleForm';

export function VehicleRegistrationDetailsGroup() {
  return (
    <>
      <VehicleForm.Field
        type="apiDate"
        name="firstRegistrationOn"
        label={i18n.t('entity.vehicle.labels.firstRegistration')}
      />
      <VehicleForm.Field
        type="choice"
        name="manufacturedOnYear"
        options={yearOptionsWithFuture}
        label={i18n.t('entity.vehicle.labels.realProductionYear')}
      />
      <VehicleForm.Field
        type="choice"
        name="manufacturedOnMonth"
        options={monthOptions}
        label={i18n.t('entity.vehicle.labels.realProductionMonth')}
      />
      <VehicleForm.Field
        type="choice"
        name="modelYear"
        options={yearOptionsWithFuture}
        label={i18n.t('entity.vehicle.labels.modelYear')}
        tooltip={i18n.t('entity.vehicle.labels.modelYearTooltip')}
      />
    </>
  );
}
